import Button from "../CustomButton/CustomButton";
import { FormattedMessage } from "react-intl";
import React from "react";

const DeleteButton = props => (
  <Button {...props} icon wd bsStyle="primary">
    <i className="fa fa-lg fa-trash-o margin-right-5" />
    <FormattedMessage id={props.ids ? props.ids : "ids_delete"} />
  </Button>
);

export { DeleteButton };
